import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { aroundItemQueueItemsEdge$key } from "~/queries/__generated__/aroundItemQueueItemsEdge.graphql";

import { Container, Content, StyledContentItemRender, Title } from "./styles";

type Props = {
  className?: string;
  reference: aroundItemQueueItemsEdge$key;
  title: string;
  urlAlias: string;
};

type HomeAroundVariant =
  | "home-around-primary"
  | "home-around-secondary"
  | "home-around-morning-studio-primary"
  | "home-around-morning-studio-secondary";

export const HomeAroundItem: FunctionComponent<Props> = ({
  className,
  reference: reference_,
  title,
  urlAlias,
}) => {
  const data = useFragment(
    graphql`
      fragment aroundItemQueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            entityId
            ...contentItemRenderContent
          }
        }
      }
    `,
    reference_,
  );

  const renderAroundItems = () => {
    const isMorningStudio = title === "MORNING STUDIO";
    return data?.map((item, key) => {
      let variant: HomeAroundVariant = key === 0 ? "home-around-primary" : "home-around-secondary";
      if (isMorningStudio) {
        variant =
          key === 0 ? "home-around-morning-studio-primary" : "home-around-morning-studio-secondary";
      }
      return (
        <StyledContentItemRender
          key={item?.node.entityId}
          reference={item?.node}
          variant={variant}
          onClick={entityId => {
            sendGATracking({
              action: "Click/around_scmp",
              category: "Homepage Depth",
              label: entityId,
            });
          }}
        />
      );
    });
  };

  return (
    <Container className={className}>
      <Title pathname={urlAlias}>{title}</Title>
      <Content>{renderAroundItems()}</Content>
    </Container>
  );
};

HomeAroundItem.displayName = "HomeAroundItem";
